import React from 'react'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { RecordView } from '../../../../../../shared/page/record-view'

import { IconEdit } from '../../../../../../shared/icon/icon'
import { Menu, MenuRemove } from '../../../../../../shared/menu/menu'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useRouteMatch } from '../../../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { RoleSelectUser } from '../../../../../../role/role-select/role-select-user'
import { useApiFormLoginUser } from '../../../../../../api-new/state/content'
import { useAuditRecord } from '../../../../../../shared/audit/history/audit-record-context'

export const OrganizationUserEdit = () => {
  const { url } = useRouteMatch()

  const { loginID, userID } = useParamsInt()

  const apiFormLoginUser = useApiFormLoginUser()

  const handlePath = () => apiFormLoginUser.get(`${userID}`)

  // History: whose membership this is, once loaded, for a reader without
  // SYS_AUDIT_LOG (record-routes.js recordOrg)
  const loaded = apiFormLoginUser.form.id === userID
  useAuditRecord({ type: 'users', id: loaded ? userID : undefined, organizationID: loaded ? apiFormLoginUser.form.organizationID : undefined })

  const HeaderMenu = () =>
    <Menu>
      <MenuRemove text="remove from organization" to={`${url}/delete/${userID}`} show pin />
    </Menu>

  return (
    <React.Fragment>
      <RecordView noun="membership" back={{ label: 'Back to organizations', to: `/admin/login/list/edit/${loginID}/organizations` }} Icon={IconEdit} text={apiFormLoginUser.form.organizationName} onPath={handlePath}>
        <CardFullHeightScrollY title={apiFormLoginUser.form.organizationName} HeaderMenu={HeaderMenu}>
          <RoleSelectUser userID={userID} />
        </CardFullHeightScrollY>
      </RecordView>
    </React.Fragment>
  )
}
